<template>
    <div>
        <v-search>
            <router-link :to="{path:'add'}">
                <a-button type="primary" style="float:right;margin-top:8px;">新增</a-button>
            </router-link>域名列表
            <!-- <span slot="filterTitle">条件筛选</span> -->
        </v-search>
        <v-tablelist></v-tablelist>
    </div>
</template>

<script>
import TableList from "./tablelist.vue";
import Search from "./search.vue";

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {},
    components: {
        "v-tablelist": TableList,
        "v-search": Search
    },
    mounted() {}
};
</script>

<style scoped>
</style>